import React, { PropsWithChildren } from 'react';

import { mosaiqStyled } from '../../lib';

import { GridContainer } from './Grid.styles';
import { GridProps } from './types';

const Grid = mosaiqStyled<PropsWithChildren<GridProps>, HTMLDivElement>(
  ({ columns = 'none', innerBorder = false, gap = 0, children, ...props }) => {
    return (
      <GridContainer $columns={columns} $innerBorder={innerBorder} gap={gap} {...props}>
        {children}
      </GridContainer>
    );
  },
);

export default Grid;
